import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { CIRCLE_COLORS, OUTSIDE_COLOR } from '../config';
import { hasOutsideDots } from '../helpers/venn';

type Props = {
  data: Matches.CategoryData;
};

const Swatch: React.FC<{ color: string; label: string }> = ({ color, label }) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
    <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.85)' }}>
      {label}
    </Typography>
  </Stack>
);

export const VennLegend: React.FC<Props> = ({ data }) => {
  if (!data.circles.length) return null;

  const showOther = hasOutsideDots(data);

  return (
    <Stack spacing={1.5} sx={{ mt: 3 }}>
      <Stack direction="row" flexWrap="wrap" justifyContent="center" rowGap={1} columnGap={3}>
        {data.circles.map((circle, index) => (
          <Swatch key={circle.id} color={CIRCLE_COLORS[index]} label={circle.label} />
        ))}
        {showOther && <Swatch color={OUTSIDE_COLOR} label="Other (not in your top 3)" />}
      </Stack>
      <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.5)', textAlign: 'center' }}>
        Each dot is an Assertion you answered and how it ties you to your top matches.
      </Typography>
    </Stack>
  );
};
